export const services = [
  {
    name: "Web development",
    label:
      "Being well-acquainted in web development services and websites we provide our customers with highly professional suggestions to meet the demands.",
    lists: [
      "Responsive and mobile web design",
      "Content strategy",
      "Digital copywriting",
      "Content reviews",
    ],
    descriptionHeader: {
      text: "We don't just sell websites, we create websites that SELL.",
      person: "Dr. Christopher Dayagdag",
    },
    description:
      "As his quote we are a top-performing Web Development and Designing agency. We believe in customer satisfaction and feedback for us, which help us to improve and being friendly with our client. Sweven Incorporate Private Limited has experience in providing web development services and establishing websites that are Responsive, High Performing and Highly Attractive using the latest web technologies for your business or professional strategy. Our web development specialists provide work revisions, feedback of management team until it doesn't make feel satisfied our customers. In professional web development services, we have to tick all the boxes of requirements of our clients. Sweven Incorporate Private Limited web development services include Responsive website, Mobile Friendly Web Designs, Customized E-commerce and Intranet experiences, keeping in mind best practices and latest technological platforms.",
    image: "/images/web-development.png",
    cards: [
      {
        title: "Web Design",
        lists: [
          "Responsive and mobile web design",
          "Web app UI design",
          "Flexible Layout",
          "Company and product sites",
          "Website reviews",
        ],
      },
      {
        title: "Web development",
        lists: [
          "Ruby on Rails development",
          "JavaScript development",
          "HTML/CSS/ PHP builds",
          "CMS integration",
        ],
      },
      {
        title: "Content",
        lists: [
          "Content strategy",
          "Digital copywriting",
          "Content reviews",
          "Customer Feedback",
          "SEO friendly strategy",
        ],
      },
    ],
    extraColors: ["#54ff00cc", "#ffe400"],
    extra: [
      {
        title: "Understanding your Imagination",
        description:
          "Whether you are looking to redesign an existing website or starting a new web project, we can help you implement your ideas and tell your story. We can create content for your site and give you the strategy to manage it. We'll help you to achieve, your business' potential on the web. Design is the main part of webpages, because it will be shown to your customer or website visitor. We will make it really pretty and awesome with our designer team and make it possible by using any kind of of platform like animation, high definition images retouch.",
        image:
          "https://www.pinclipart.com/picdir/middle/264-2642982_bulb-vector-png-png-download-clipart.png",
      },
      {
        title: "Help to improve your content",
        description:
          "If you are trouble in writing your web content, don't panic we can help you to write the content for your website to make more attractive. Yeah! it's difficult to write in any subject for the first time. We will understand your thought and we will write about that with your real feelings.",
        image:
          "https://cdn4.iconfinder.com/data/icons/devices-gaming/24/certificate-512.png",
      },
    ],
  },
  {
    name: "Software development",
    label:
      "We assist you in developing any desktop and web based or andriod and ios based applications according to your need.",
    lists: [
      "Desktop Software",
      "Mobile Application",
      "Web Application",
      "Compatible with different types of OS",
    ],
    descriptionHeader: {
      text:
        "Software innovation, like almost every other kind of innovation, requires the ability to collaborate and share ideas with other people, and to sit down and talk with customers and get their feedback and understand their needs",
      person: "Bill gates",
    },
    description:
      " As our best mentor quote, we believe to make imagination come true which should call as innovation. Our moto supports the innovation. Our team helps to you make any desktop and web basis or android and iOs basis applications or software with your requirement. Our team specialized custom software manages some of the vital businesses throughout the globe and has formed an integral part of small to large enterprises. Customized development of software not only offers rich features and tools to make your work easy, but also provides you with dedicated support. You just need one tap to get into the extremely lucrative mobile space with our unique, simple, and intuitive apps. Our experts can help you design and develop beautiful, innovative and unique mobile apps that can work as standalone apps or can even be integrated with existing app or a website. Sweven Incorporate Private Limited team believe in final consumer satisfactory which means is your satisfaction and our satisfaction as well.",
    image: "/images/software-development.png",
    cards: [
      {
        title: "Desktop Software",
        lists: [
          "Customized with modern tools",
          "Compatible with different types of OS",
          "Flexible Layout",
          "MSQL, .NET, PHP, Javascript",
        ],
      },
      {
        title: "Mobile Application",
        lists: [
          "Android & iOs support",
          "Android studio, Kotlin, MongooDB, Laravel source code",
          "Flexible layout for all smartphones",
        ],
      },
      {
        title: "Web Application",
        lists: [
          "Lite Version",
          "Flexible Layout in all types of browser",
          "User friendly",
          "Security priority",
        ],
      },
    ],
    extraColors: ["#00ffa8", "#fff000"],
    extra: [
      {
        title: "Design with your choice",
        description:
          "Software and application are the best way to interact with consumer directly. Software and mobile application design should attract consumer to again connect with you we know it so, we make it easy design with our best designer team for your help. Desktop software is most usable in business sector and it will be suitable for employee and professional too so, we can feel that ease and support for your side and android application or web application should be user friendly when you think you are in trouble we attend there and we support your dream with our experience.",
        image:
          "https://cdn.pixabay.com/photo/2014/04/02/10/59/bulb-305162_960_720.png",
      },
      {
        title: "Help to improve your content",
        description:
          "If you are trouble in writing your content, don't panic we can help you to write the content for your software and mobile applications to make more attractive. Yeah! it's difficult to write in any subject for the first time. We will understand your thought and we will write about that with your real feelings.     We know you are the you are service provider and final consumer is your business client so, we provide the best help content tools to ease your service and consumer benefits.",
        image: "https://www.freeiconspng.com/uploads/content-marketing-6.png",
      },
    ],
  },
  {
    name: "Graphic design",
    label:
      "Picture speaks louder than words. In addition to the aesthetic appeal, graphics design can bring your social media, blog and landing pages to life, breaking up the text with visual elements. We help you to achieve it.",
    lists: ["Illustrating", "Infographics", "Calls To Action (CTA)"],
    descriptionHeader: {
      text:
        "Design is not just what it looks like and feels like. Design is how it works.",
      person: "Steve Jobs",
    },
    description:
      "Graphic Design adds a whole new dimension to your Content Creation efforts. If you have graphic designers on staff or access to them through an agency you’re no longer confined to words and stock images. Graphic Design can bring your social media, blog and landing pages to life, breaking up the text with visual elements. These don’t just improve the aesthetic appeal of your pages; they also serve to communicate your key messages more effectively. Research has shown that when information is presented in visual form the human brain processes it quicker and retains it longer. If you look at the results of any eye-tracking study, it’s the parts of the page that aren’t plain text that get all the attention.",
    image: "/images/graphic-design.png",
    cards: [
      {
        title: "Illustrating",
        lists: [
          "Logo Design",
          "Stylish vector design",
          "Marketing Advertisement banner",
          "Browser Design",
        ],
      },
      {
        title: "Calls To Action (CTA)",
        lists: [
          "Brand-consistent Banner",
          "Web, Applications Buttons & Forms",
          "Simple & Stylish clickable design",
        ],
      },
      {
        title: "Infographics",
        lists: [
          "Trend & Bar Lines",
          "Short Animated Data Graphics",
          "Useful & Coherent Story",
        ],
      },
    ],
    extraColors: ["#00ff90", "#ddfffd"],
    extra: [
      {
        title: "Your brand and our design",
        description:
          "Our graphic design agency exists to help you design effective graphics that will elevate your brand. Our graphic designers consist of world-class talent and will relieve you of the stress of developing graphics for your business. Whether you need graphic design for traditional media or digital media, our graphic designers will be here to help you.",
        image:
          "https://images.all-free-download.com/images/graphicthumb/hands_logo_design_vector_535402.jpg",
      },
      {
        title: "Improving your data with design",
        description:
          "The first is on landing pages where a client is trying to explain a complex process or highlight their USPs (what it is that makes them different to the competition). Infographics do a great job of conveying lots of information in a digestible and visually appealing manner. If users understand what you’re trying to say they’re more likely to trust you and therefore more likely to convert into a lead or customer. The second situation where we often pitch infographics is when a client is looking for a premium blog post to promote on social media. We are helping you to make more reliable and customized design for data with best tools and skills.",
        image:
          "https://banner2.kisspng.com/20180318/vtw/kisspng-computer-data-information-clip-art-vector-computer-information-data-5aaed67861ed86.5070142215214076084011.jpg",
      },
    ],
  },
  {
    name: "Multimedia services",
    label:
      "Nothing tells your brand’s story better than QUALITY photos and videos for your website or social media platforms. At Sweven Incorporate Private Limited, we have a team of photographers and videographers, photo stylist and photo editors to ensure that the right story is portrayed in your imagery.",
    lists: [
      "Photography",
      "Photo edit, Retouch",
      "Videography",
      "Advertisement video shoot",
    ],
    descriptionHeader: {
      text:
        "Everything is cross-platform now. That's part of the reality that we live in - a multifaceted, multimedia world - and I'm delighted to be a part of that.",
      person: "Robert J. Sawyer",
    },
    description:
      "Nothing tells your brand’s story better than QUALITY photos and video for your website or social media platforms. At Sweven Incorporate Private Limited, we have a team of photographers and videographers, photo stylist and photo editors to ensure that the right story is portrayed in your imagery. Whether it be food photography, action photography, interior photography or social media content, Sweven Incorporate Private Limited specializes in creating the right photos and videos for your business. We are constantly upgrading our photography and videography equipment which includes drone, DSLR cameras, studio equipment and more, to ensure we capture the right photography and videography for whatever purpose you need and we serve to retouch it.",
    image: "/images/multimedia-services.png",
    cards: [
      {
        title: "Photography",
        lists: [
          "Action, Food, Business, Event & Fashion Photography",
          "Photo edit, Retouch",
          "Marketing Advertisement Photography",
          "Using Photoshop, Lightroom, Pixler and other tools",
        ],
      },
      {
        title: "Videography",
        lists: [
          "Advertisement video shoot",
          "Social media video",
          "Short movie shoot",
          "Event video shooting",
          "3D Animation",
          "Using Aftereffect, blender, Filmora and many other tools",
        ],
      },
    ],
    extraColors: ["#f6dc00cc", "#2a00e122"],
    extra: [
      {
        title: "Retouching photo",
        description:
          "Every photographer is aware that a flawless look is necessary for a photograph to be a perfect image. We work with professional photographers and editor to make every click look picture-perfect. With our range of outsource image editing services, we cater to ecommerce product image editing services, real estate photo editing, to name a few. With our quality, accessibility and reliability, we have become a reputed photo editing company providing professional photo editing services.",
        image:
          "https://png.pngtree.com/element_our/sm/20180716/sm_5b4cb2bca9fb7.png",
      },
      {
        title: "Sweet Ingredients for great moment",
        description:
          "Editing is the process of gathering and producing assets such as videos, photos, music, titles, animations, logos and beauty shots. These are the ingredients that make for a great video. With over 15 years of experience, the pros in our team will be your high-quality production company at a reasonable price. There are no hidden charges for our services. We know life can be very hectic at times and even more so when preparing for your special event. We provide you raw footage on a DVD for your memorable moment without editing because we accept reality is far better than artificial.",
        image:
          "https://banner2.kisspng.com/20180318/vtw/kisspng-computer-data-information-clip-art-vector-computer-information-data-5aaed67861ed86.5070142215214076084011.jpg",
      },
    ],
  },
  {
    name: "Digital Marketing and SEO",
    label:
      "The expertise offered by our technical and copywriting staff enables Sweven Incorporate Private Limited to successfully meet the needs of companies with complex websites in competitive industries.",
    lists: [
      "SEO",
      "Content Creation",
      "Social Media Promotions",
      "Creative content promotion",
    ],
    descriptionHeader: {
      text:
        "No website can stand without a strong backbone. And that backbone is technical SEO.",
      person: "Neil Patel",
    },
    description:
      "Sweven Incorporate Private Limited can increase the search engine rank and site traffic of any company. The expertise offered by its technical and copywriting staff enables Sweven Incorporate Private Limited to successfully meet the needs of companies with complex websites in competitive industries. Sweven Incorporate Private Limited caters to clients who require an intensive, full-service approach to search engine marketing. As experts in the search engine optimization and marketing industries, the management and employees of Sweven Incorporate Private Limited have a proven track record for crafting effective Internet marketing strategies with measurable, long-term results. Our team follow the recent public trend and smoothly grab that opportunity with the best tools and skills. ",
    image: "/images/SEO.png",
    cards: [
      {
        title: "SEO Service",
        lists: [
          "SEO Audit",
          "SEO Optimization",
          "Content Creation",
          "Local SEO building",
        ],
      },
      {
        title: "Social Site Promotion",
        lists: [
          "Youtube, Facebook, Instagram, Twitter Promotion",
          "Link Building",
          "Creative content promotion",
        ],
      },
    ],
    extraColors: ["#ffdd8b", "#29ff98"],
    extra: [
      {
        title: "Laser Targeted Content Creation",
        description:
          "Content that is wrapped around relevant keywords can do wonders when it comes to SEO and Digital Marketing. We make sure all your website content, blogs, and other marketing material is wrapped around keywords for maximum impact. When it comes to SEO and Social Promotion or Digital Marketing, content matters! Our team of creative content writers are well aware of this fact and do their best in aligning your business objectives to your target audience in the best way possible.",
        image:
          "https://image.flaticon.com/sprites/new_packs/235167-reports-and-analytics.png",
      },
      {
        title: "Detailed Reporting",
        description:
          "You’ll be never in the dark about what we are doing to increase the visibility of your business. We provide detailed reports for everything we do to make sure you are on the same page as us. Updated and Skillful our team keeps you to update in digital world so, we feel the business emotions and act on that.",
        image:
          "https://www.rpmhst.com/uploads/5/6/5/4/56543961/s443917594316243308_p144_i2_w416.png",
      },
    ],
  },
];
